import React, { useEffect, useState } from "react";
import api from "../services/api";
import { Toast } from "./Toast";
import { roles } from "../utils/constants";
import { useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";
import config from "../config";
import BrandChecker from "../components/MakerChecker/BrandChecker"

const Checker = () => {
  const [data, setData] = useState(null);
  const [route, setRoute] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const getPath = async (mc_id) => {
    try {
      let res = await api({
        url: "/makerchecker/get",
        method: "POST",
        responseType: "json",
        data: { encryptedId: mc_id },
      });
      console.log(res);
      if (res.code === 200) {
        if (res?.data?.status !== 0 ) {
          Toast("error", "Action Already Taken By Another Checker");
          navigateAfterAction();
          return;
        }
        setData(res.data);
        setRoute(res.data?.route);
      } 
      else if(res?.data?.code === 400)
      { 
        Toast("error",res?.data?.message || "Failed to fetch data");
        navigateAfterAction();
        localStorage.removeItem('mc_id');
      }
    } catch (err) {
      console.error(err);
      Toast("error", "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const mc_id = localStorage.getItem("mc_id");
    if (!mc_id) {
      navigate("/pagenotfound");
      return;
    }
    getPath(mc_id);
  }, []);

  const approve = async () => {
    try {
      let res = await api({
        url: route,
        method: "POST",
        responseType: "json",
        data: {
          encryptedId: localStorage.getItem("mc_id") || "",
          isapprove: true,
        },
      });

      if (res.code === 200) {
        localStorage.removeItem("mc_id");
        Toast("success", "Approved Successfully");
        navigateAfterAction();
      } else {
        Toast("error", res?.data?.message);
        navigateAfterAction();
      }
    } catch (err) {
      console.error(err);
    }
  };

  const reject = async (reason) => {
    try {
      let res = await api({
        url: route,
        method: "POST",
        responseType: "json",
        data: {
          encryptedId: localStorage.getItem("mc_id") || "",
          isapprove: false,
          rejreason: reason,
        },
      });

      if (res.code === 200) {
        localStorage.removeItem("mc_id");
        Toast("success", "Rejected Successfully");
        navigateAfterAction();
      } else {
        Toast("error", res?.data?.message);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const navigateAfterAction = () => {
    let role = localStorage.getItem('role');
    console.log(role);
    if (role === roles.ops) navigate("/home/order");
    else if (role === roles.salesperson) {

      if(localStorage.getItem('discount-obj')?.length > 0){
        navigate(`/home/discount/${localStorage.getItem('discount-obj')}`)
      }
      else if(localStorage.getItem('slot-id')?.length > 0){
        navigate(`/home/slotbooking/${localStorage.getItem('slot-id')}`)
      }
      else
      navigate("/home/sales/dashboard");
    } else if (role === roles.financer) navigate("/home/order");
    else if (role === roles.advertiser) navigate("/home/dashboard");
    else if (role === roles.content_writer) navigate("/home/designer-requests")
    else if(role === roles.designer) navigate("/home/designer-requests");
    else if (role === roles.network_ad_manager)
      navigate("/home/networkads/queued");
    else if (role === roles.legalperson) {
      if(localStorage.getItem('discount-obj')?.length > 0){
        navigate(`/home/discount/${localStorage.getItem('discount-obj')}`)
      }else
      navigate("/home/order");
    } else if (role === roles.b2b && localStorage.getItem("b2b")) {
      const encryptedPermissions = localStorage.getItem("b2b");

      // Decrypt the permissions with the same secret key
      const decryptedPermissionsBytes = CryptoJS.AES.decrypt(
        encryptedPermissions,
        config.B2B_SECRET_KEY
      );

      // Convert the decrypted bytes back to a JSON string
      const decryptedPermissionsJSON = decryptedPermissionsBytes.toString(
        CryptoJS.enc.Utf8
      );

      // Parse the JSON string to get the original object
      const b2b_permissions = JSON.parse(decryptedPermissionsJSON)[0];

      if (b2b_permissions.newspaperData) {
        navigate("/home/competitor_data/get");
      } else if (b2b_permissions.b2bData) {
        navigate("/home/b2b_contacts/get");
      } else if (b2b_permissions.agencyData) {
        navigate("/home/agency_data/get");
      } else if (b2b_permissions.competitorData) {
        navigate("/home/competitor_reports/get");
      } else if (b2b_permissions.requests) {
        navigate("/home/b2b_requests/get");
      } else {
        navigate("/home/competitor_data/get");
      }
    } else {
      navigate("/pagenotfound");
    }
  };

  const renderChild = () => {
    if (!data) return null;

    const commonProps = {
      data: data,
      onApprove: approve,
      onReject: reject,
      navigation:navigateAfterAction,
      isfromMail:true,
    };
    console.log(data);
    switch (data.action_type) {
      case 1:
      case 2:
          return <BrandChecker {...commonProps} />;
      default:
        return <div>Unsupported action type: {data.actiontype}</div>;
    }
  };

  if (loading) return <div className="text-center">Loading...</div>;

  return <div>{renderChild()}</div>;
};

export default Checker;
